(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvCurrencyInput', drvCurrencyInput);

    /**
     * @ngdoc directive
     * @name drvCurrencyInput
     * @description Currency input
     *
     * @param {number} value - The numeric value of the currency amount
     * @param {object} field - An entity field object with properties such as 'HelpText', 'Mandatory', etc.
     */
    function drvCurrencyInput() {
        return {
            templateUrl: 'app/fieldinput/currency-input.tmpl.html',
            require: 'ngModel',
            scope: {},
            controller: drvCurrencyInputCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                value: '=ngModel',
                field: '='
            }
        };
    }

    drvCurrencyInputCtrl.$inject = [];

    function drvCurrencyInputCtrl() {
        /* jshint validthis:true */
        var drvCtrl = this;
    }
})();